module.exports = __webpack_public_path__ + "static/media/k_rahe_xa.5dc1661e.ogg";